import { lazyLoad } from 'utils/loadable';

export const CourseFormPage = lazyLoad(
  () => import('./index'),
  module => module.CourseFormPage,
);
